import styled from 'styled-components';
import Label from '../../../../Form/Label';
export const Wrapper = styled.div `
  padding: 8px 12px;
  background-color: ${({ theme }) => theme.colors.grey00_1};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey10_1};
  display: flex;
  gap: 8px;
  align-items: flex-start;
`;
export const LabelWrapper = styled(Label) `
  white-space: nowrap;
`;
